import { Plugin } from '../../renderer';
import { Ref } from '../ref';
export class RefPlugin extends Plugin {
    setProp(node, prop, target) {
        if (prop === '_ref' && target instanceof Ref) {
            target.resolve(node);
            return true;
        }
        return false;
    }
    priority() {
        return Plugin.PriorityFallback;
    }
}
//# sourceMappingURL=ref.plugin.js.map